import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import moment from 'moment';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function manageChecklistFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getJobChecklistFolderList();
}

export function addJobChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    //设置默认选择的Folder和Group
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Comments'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      //ChecklistStatusSetId设置备选项里第一个
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
        getChecklistStatusSelectOptionList({ sectionName: sectionName, parameter: sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
      }

      //ChecklistStatusId设置备选项里第一个
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusId'] !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', null);
      }

      //设置联动的Select
      getChecklistFolderSelectOptionList({ sectionName: sectionName, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
      getChecklistGroupSelectOptionList({ sectionName: sectionName, parameter: parameter.JobChecklistFolderId, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function editJobChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let jobChecklistIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    folder.JobChecklistGroupList.map(group => {
      group.JobChecklistList.map(jobChecklist => {
        jobChecklistIds.push(jobChecklist.JobChecklistId);
      })
    })
  });
  let index = jobChecklistIds.indexOf(parameter.key);

  if (index === 0) {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', previousButtonDisabled: true });
  } else {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', previousButtonDisabled: false });
  }
  if (index === jobChecklistIds.length - 1) {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', nextButtonDisabled: true });
  } else {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', nextButtonDisabled: false });
  }

  // sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
        if (data.data['Comments'] === null) {
          data.data['Comments'] = '';
        }
        if (data.data['Note'] === null) {
          data.data['Note'] = '';
        }
        if (data.data['RfiResponse'] === null) {
          data.data['RfiResponse'] = '';
        }
        if (data.data['Decision'] === null) {
          data.data['Decision'] = '';
        }
        if (data.data['JobChecklistFolderId'] === null) {
          data.data['JobChecklistFolderId'] = 0;
        }

        //把处理后的数据赋值给表单
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
        sectionComponent.customForm.current?.setState({ formData: data.data });

        setTimeout(() => {
          //设置联动的Select
          getChecklistFolderSelectOptionList({ sectionName: sectionName, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
          getChecklistGroupSelectOptionList({ sectionName: sectionName, parameter: data.data['JobChecklistFolderId'], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
          getChecklistStatusSelectOptionList({ sectionName: sectionName, parameter: data.data['ChecklistStatusSetId'], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
          sectionComponent.setState({ isFormModified: false });
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();

  formComponent.props.component.groupList.filter(c => c.show).forEach(group => {
    group.uieList.forEach(uie => {
      if (uie.component === 'DatePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'ColorPicker') {
        if (form[uie.source] !== undefined) {
          form[uie.source] = form[uie.source].hex
        } else {
          form[uie.source] = null;
        }
      }
    });
  });

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }

  form.key = formComponent.state.currentDataKey;
  console.log(sectionComponent.state.componentType + ' 提交的表单', form);

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ customFormSubmitting: false });
            setTimeout(() => {
              formComponent.resetFields();
              sectionComponent.setState({ showModal: false });
              let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
              let isGroupFound = false;
              for (let section of updatedData) {
                // 遍历JobChecklistGroupList
                for (let group of section.JobChecklistGroupList) {
                  // 找到与给定JobChecklistGroupId匹配的group
                  if (group.key === data.data.JobChecklistGroupId) {
                    // 向JobChecklistList数组中添加新的JobChecklist
                    if (Array.isArray(group.JobChecklistList)) {
                      group.JobChecklistList.push(data.data);
                    } else {
                      // 如果JobChecklistList不存在或不是数组，则初始化并添加
                      group.JobChecklistList = [data.data];
                    }
                    isGroupFound = true;
                    break;  // 如果找到并添加了JobChecklist，则退出循环
                  }
                }
                if (isGroupFound) break;
              }
              sectionComponent.child.current?.setState({ data: updatedData });

              let jobChecklistIds = [];
              updatedData.map(folder => {
                folder.JobChecklistGroupList.map(group => {
                  group.JobChecklistList.map(jobChecklist => {
                    jobChecklistIds.push(jobChecklist.JobChecklistId);
                  })
                })
              });
              if (jobChecklistIds.length < 2) {
                sectionComponent.setState({ previousButtonDisabled: true, nextButtonDisabled: true });
              } else {
                sectionComponent.setState({ previousButtonDisabled: false, nextButtonDisabled: false });
              }

            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ customFormSubmitting: false });
            setTimeout(() => {
              if (sectionComponent.state.closeModelAfterSubmit !== false) {
                formComponent.resetFields();
                sectionComponent.setState({ showModal: false });
              }
              let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
              let isGroupFound = false;

              // 假设 data.data 包含了更新的 jobChecklist 信息
              const newJobChecklist = data.data;
              const newJobChecklistGroupId = newJobChecklist.JobChecklistGroupId; // 获取新的组ID
              const newJobChecklistFolderId = newJobChecklist.JobChecklistFolderId; // 获取新的FolderID

              let oldJobChecklistGroupId;

              updatedData.map(section => {
                section.JobChecklistGroupList.map(group => {
                  group.JobChecklistList.filter(jobChecklist => {
                    if (jobChecklist.key === newJobChecklist.key) {
                      oldJobChecklistGroupId = group.JobChecklistGroupId; // 获取旧的组ID
                    }
                  })
                })
              });

              //判断是否换组了
              if (newJobChecklistGroupId === oldJobChecklistGroupId) {
                //没有换组, 直接替换原数据
                updatedData = updatedData.map(section => {
                  return { // 确保返回更新后的 section
                    ...section,
                    JobChecklistGroupList: section.JobChecklistGroupList.map(group => {
                      return { // 确保返回更新后的 group
                        ...group,
                        JobChecklistList: group.JobChecklistList.map(jobChecklist => {
                          if (jobChecklist.key === newJobChecklist.key) {
                            return newJobChecklist; // 返回新的 jobChecklist
                          }
                          return jobChecklist;
                        })
                      };
                    })
                  };
                });
              } else {
                //换组了, 重新分组
                // 首先找到并删除旧的 jobChecklist
                updatedData = updatedData.map(section => {
                  return {
                    ...section,
                    JobChecklistGroupList: section.JobChecklistGroupList.map(group => {
                      const filteredJobChecklists = group.JobChecklistList.filter(jobChecklist => {
                        if (jobChecklist.key === newJobChecklist.key) {
                          oldJobChecklistGroupId = group.JobChecklistGroupId; // 获取旧的组ID
                          return false; // 从旧的组中移除
                        }
                        return true;
                      });
                      return {
                        ...group,
                        JobChecklistList: filteredJobChecklists
                      };
                    })
                  };
                });

                console.log(newJobChecklist);
                // 然后将新的 jobChecklist 添加到新的组中
                let groupFound = false;
                updatedData = updatedData.map(section => {
                  return {
                    ...section,
                    JobChecklistGroupList: section.JobChecklistGroupList.map(group => {
                      if (group.JobChecklistGroupId === newJobChecklistGroupId) {
                        groupFound = true;
                        return {
                          ...group,
                          JobChecklistList: [...group.JobChecklistList, newJobChecklist]
                        };
                      }
                      return group;
                    })
                  };
                });


                //没找到，需要新建一个组插入
                if (!groupFound) {
                  let newGroup = {
                    key: newJobChecklist.JobChecklistGroupId,
                    JobChecklistGroupId: newJobChecklist.JobChecklistGroupId,
                    Name: newJobChecklist.GroupName,
                    JobId: sectionComponent.props.jobId,
                    Sort: 255, // 你可能需要根据实际情况设置排序
                    JobChecklistFolderId: newJobChecklist.JobChecklistFolderId,
                    BackgroundColor: '#2196F3', // 默认背景色
                    JobChecklistList: [newJobChecklist]
                  };

                  const targetFolderId = newJobChecklistFolderId === null ? 0 : newJobChecklistFolderId;
                  // 找到对应的 section 并添加新的 group
                  let sectionFound = false;

                  updatedData = updatedData.map(section => {
                    if (section.JobChecklistFolderId === targetFolderId) {
                      sectionFound = true;
                      return {
                        ...section,
                        JobChecklistGroupList: [...section.JobChecklistGroupList, newGroup]
                      };
                    }
                    return section;
                  });
                }
              }

              sectionComponent.child.current?.setState({ data: updatedData });

            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

export function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .delete(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
        let isGroupFound = false;

        // 第一步：从数据中找到并删除旧的 jobChecklist
        const removeOldJobChecklist = (data, key) => {
          let found = false; // 用于标记是否找到并删除了旧的 jobChecklist
          const newData = data.map(section => {
            const newGroupList = section.JobChecklistGroupList.map(group => {
              const newJobChecklistList = group.JobChecklistList.filter(jobChecklist => {
                if (jobChecklist.key === key) {
                  found = true;
                  return false; // 如果找到了匹配的 key，我们将其从数组中过滤掉
                }
                return true;
              });
              return { ...group, JobChecklistList: newJobChecklistList };
            });
            return { ...section, JobChecklistGroupList: newGroupList };
          });
          return { newData, found };
        };
        // 执行删除操作
        const { newData, found } = removeOldJobChecklist(updatedData, parameter.key);
        sectionComponent.child.current?.setState({ data: newData });


        let jobChecklistIds = [];
        newData.map(folder => {
          folder.JobChecklistGroupList.map(group => {
            group.JobChecklistList.map(jobChecklist => {
              jobChecklistIds.push(jobChecklist.JobChecklistId);
            })
          })
        });
        if (jobChecklistIds.length < 2) {
          sectionComponent.setState({ previousButtonDisabled: true, nextButtonDisabled: true });
        } else {
          sectionComponent.setState({ previousButtonDisabled: false, nextButtonDisabled: false });
        }
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getChecklistFolderSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Business/JobChecklistFolder/GetSelectOptionList?jobId=' + formComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['JobChecklistFolderId'] = dataSource;
        formComponent.setState({ componentDataSource });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getChecklistGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  // Folder 下拉框初始化时可能尚未写入表单，跳过这次无效的联动请求。
  if (parameter === undefined) return;

  httpClient
    .get('Business/JobChecklistGroup/GetSelectOptionList?jobId=' + formComponent.props.jobId + (parameter !== null ? '&parameterId=' + parameter : ''))
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        dataSource = dataSource.filter(item => item.Value !== 0);
        componentDataSource['JobChecklistGroupId'] = dataSource;

        let autoCompleteDataSource = data.data
          .filter(item => item.Value !== 0)
          .map(item => ({
            label: item.Key,
            value: item.Key
          }));

        componentDataSource['GroupName'] = autoCompleteDataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('JobChecklistGroupId')).length === 0) {
            //搜到的数据源不包括当前值, 说明更换了Folder, Group选择新Folder里第一个值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('JobChecklistGroupId', dataSource[0].Value);
          }
        } else {
          //搜不到数据源, 移除Group
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('JobChecklistGroupId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getChecklistStatusSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', parameter);
  httpClient
    .get('Admin/ChecklistStatus/GetSelectOptionList?parameterId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        dataSource = dataSource.filter(item => item.Value !== 0);
        componentDataSource['ChecklistStatusId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('ChecklistStatusId')).length === 0) {
            //搜到的数据源不包括当前值, 说明更换了StatusSet, Status选择新StatusSet里第一个值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', dataSource[0].Value);
          }
        } else {
          //搜不到数据源, 移除Status
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: sectionComponent.child.current, jobChecklistFolderId: 0 });
}

export function openAddFromTemplate({ component, jobChecklistFolderId } = {}) {
  component.setState({ jobChecklistFolderId: jobChecklistFolderId, addFromTemplateShow: true, });
  component.addFromTemplate.current?.setState({ activeKey: 0, typeToFilerTemplate: null });
  setTimeout(() => {
    component.addFromTemplate.current?.formRef.current?.resetFields();
    component.addFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], checklistTemplatePresetContentList: [] });
    setTimeout(() => {
      component.addFromTemplate.current?.additionalFormRef.current?.child.current?.getChecklistTemplateData();
      component.addFromTemplate.current?.getChecklistTemplatePresetDataSource();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  openManageGroup({ component: sectionComponent.child.current, jobChecklistFolderId: 0 });
}

export function openManageGroup({ component, jobChecklistFolderId } = {}) {
  component.setState({ jobChecklistFolderId: jobChecklistFolderId, manageGroupShow: true });
  setTimeout(() => {
    component.manageGroup.current?.getJobChecklistGroupList();
    component.manageGroup.current?.setState({ selectedRowKeys: [] });
  }, config.setTimeoutMilliSecond);
}

export function collapseAllGroups({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, i) => {
      group.Collapsed = true;
      return group;
    });
    return folder;
  });
  sectionComponent.child.current?.setState({ data });
}

export function collapseGroup({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, j) => {
      if (group.key === key) {
        if (group.Collapsed !== true) {
          group.Collapsed = true;
        } else {
          group.Collapsed = false;
        }
      }
      return group;
    });
    return folder;
  });
  component.setState({ data });
}

export function collapseFolder({ component, key, pageComponent } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
      //写后台
      httpClient
        .put('Business/JobChecklistFolder/Collapse', { key: key, Collapsed: folder.Collapsed })
        .then(({ data }) => {
          if (data.result) {

          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
    return folder;
  });
  component.setState({ data });
}

export function quickChangeStatus({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, j) => {
      group.JobChecklistList.map((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.Loading = true;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ data: updatedData });

    //写后台
    httpClient
      .put('Business/JobChecklist/QuickChangeStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
            folder.JobChecklistGroupList.map((group, j) => {
              group.JobChecklistList.map((jobChecklist, k) => {
                if (jobChecklist.key === parameter.key) {
                  jobChecklist.ChecklistStatusId = data.data.ChecklistStatusId;
                  jobChecklist.ChecklistStatusName = data.data.ChecklistStatusName;
                  jobChecklist.ChecklistStatusBackgroundColor = data.data.ChecklistStatusBackgroundColor;
                  jobChecklist.Loading = false;
                }
                return jobChecklist;
              })
              return group;
            });
            return folder;
          });
          // sectionComponent.child.current?.setState({ data: [] });
          setTimeout(() => {
            let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
            sectionComponent.child.current?.setState({ data: updatedData });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

export function showStatusMenu({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ event: e, statusMenuShow: true, checklistStatusSetId: parameter.ChecklistStatusSetId, jobChecklistId: parameter.JobChecklistId });
  e.preventDefault();
  return false;
}

export function getChecklistStatusSets({ sectionComponent, pageComponent } = {}) {
  //写后台
  httpClient
    .get('Admin/ChecklistStatusSet/GetList')
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.setState({ checklistStatusSets: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function changeStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  //写后台
  httpClient
    .put('Business/JobChecklist/ChangeStatus', { key: parameter.key, ChecklistStatusId: parameter.checklistStatusId })
    .then(({ data }) => {
      if (data.result) {
        let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
          folder.JobChecklistGroupList.map((group, j) => {
            group.JobChecklistList.map((jobChecklist, k) => {
              if (jobChecklist.key === parameter.key) {
                jobChecklist.ChecklistStatusId = data.data.ChecklistStatusId;
                jobChecklist.ChecklistStatusName = data.data.ChecklistStatusName;
                jobChecklist.ChecklistStatusBackgroundColor = data.data.ChecklistStatusBackgroundColor;
              }
              return jobChecklist;
            })
            return group;
          });
          return folder;
        });
        // sectionComponent.child.current?.setState({ data: [] });
        setTimeout(() => {
          let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
          sectionComponent.child.current?.setState({ statusMenuShow: false, data: updatedData });
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function openInlineEditor({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.forEach((group, j) => {
      group.JobChecklistList.forEach((jobChecklist, k) => {
        switch (uie.source) {
          case 'Comments':
            if (jobChecklist.key === parameter.key) {
              jobChecklist.editComments = true;
              jobChecklist.editNote = false;
            } else {
              jobChecklist.editComments = false;
              jobChecklist.editNote = false;
            }
            break;
          case 'Note':
            if (jobChecklist.key === parameter.key) {
              jobChecklist.editNote = true;
              jobChecklist.editComments = false;
            } else {
              jobChecklist.editNote = false;
              jobChecklist.editComments = false;
            }
            break;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  // 获取当前滚动位置
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ data: updatedData });
    setTimeout(() => {
      window.scrollTo(0, scrollTop);
    }, 40);
  }, config.setTimeoutMilliSecond);
}

//提交inline编辑Comments
export function quickEditComments({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.forEach((group, j) => {
      group.JobChecklistList.forEach((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.editComments = false;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ statusMenuShow: false, data: updatedData });
  }, config.setTimeoutMilliSecond);

  //写后台
  httpClient
    .put('Business/JobChecklist/QuickEditComments', { key: parameter.key, Comments: parameter.Comments })
    .then(({ data }) => {
      if (data.result) {
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//取消inline编辑Comments
export function cancelEditComments({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.forEach((group, j) => {
      group.JobChecklistList.forEach((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.editComments = false;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ statusMenuShow: false, data: updatedData });
  }, config.setTimeoutMilliSecond);
}

//提交inline编辑Note
export function quickEditNote({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.forEach((group, j) => {
      group.JobChecklistList.forEach((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.editNote = false;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ statusMenuShow: false, data: updatedData });
  }, config.setTimeoutMilliSecond);

  //写后台
  httpClient
    .put('Business/JobChecklist/QuickEditNote', { key: parameter.key, Note: parameter.Note })
    .then(({ data }) => {
      if (data.result) {
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//取消inline编辑Note
export function cancelEditNote({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.forEach((group, j) => {
      group.JobChecklistList.forEach((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.editNote = false;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    // sectionComponent.child.current?.setState({ data: [] });
    let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
    sectionComponent.child.current?.setState({ statusMenuShow: false, data: updatedData });
  }, config.setTimeoutMilliSecond);
}

export function getSectionDataByChecklistStatusSet({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie, loadData = true } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;

  let searchParameter = {};
  searchParameter.ChecklistStatusId = parameter;
  searchParameter.JobId = sectionComponent.props.jobId;

  sectionComponent.setState({ searchParameter, componentDefaultValue });
  if (loadData) {
    setTimeout(() => {
      sectionComponent.child.current?.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

export function getSectionDataByChecklistStatusName({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie, loadData = true } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;

  let searchParameter = {};
  searchParameter.ChecklistStatusName = parameter;
  searchParameter.JobId = sectionComponent.props.jobId;

  sectionComponent.setState({ searchParameter, componentDefaultValue });
  if (loadData) {
    setTimeout(() => {
      sectionComponent.child.current?.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

export function batchUpdateStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ updateStatusShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.updateStatus.current?.getChecklistStatusSets();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one checklist item.');
  }
}

export function batchChangeGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ changeGroupShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.changeGroup.current?.getChecklistGroups();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one checklist item.');
  }
}


export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/JobChecklist/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one checklist item.');
  }
}

//上传Image
export function uploadImage({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.attachImage.current?.setState({
    show: true,
    submitting: false,
    jobChecklistId: parameter.JobChecklistId
  });

  setTimeout(() => {
    console.log(sectionComponent.child.current?.attachImage.current?.state);
  }, 100);
}

//删除JobChecklistImage
export function deleteJobChecklistImage({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .delete('Business/JobChecklist/DeleteJobChecklistImage/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let jobChecklistData = sectionComponent.child.current?.state.data.map(folder => {
          folder.JobChecklistGroupList.map(group => {
            group.JobChecklistList.map(jobChecklist => {
              if (jobChecklist.JobChecklistImageList !== null) {
                jobChecklist.JobChecklistImageList = jobChecklist.JobChecklistImageList.filter(item => item.key !== parameter.key);
              }
              if (jobChecklist.JobChecklistDocumentList !== null) {
                jobChecklist.JobChecklistDocumentList = jobChecklist.JobChecklistDocumentList.filter(item => item.key !== parameter.key);
              }
              return jobChecklist;
            })
            return group;
          })
          return folder;
        });

        setTimeout(() => {
          // sectionComponent.child.current?.setState({ data: [] });
          let updatedData = JSON.parse(JSON.stringify(jobChecklistData));
          sectionComponent.child.current?.setState({ data: updatedData });
        }, 10);
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getPreviousJobChecklist({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let jobChecklistIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    folder.JobChecklistGroupList.map(group => {
      group.JobChecklistList.map(jobChecklist => {
        jobChecklistIds.push(jobChecklist.JobChecklistId);
      })
    })
  });

  let index = jobChecklistIds.indexOf(parameter) - 1;
  if (index >= 0 && index <= jobChecklistIds.length - 1) {
    let id = jobChecklistIds[index];
    editJobChecklist({ parameter: { key: id }, sectionComponent, pageComponent, sectionName, uie });
  }

}

export function getNextJobChecklist({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let jobChecklistIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    folder.JobChecklistGroupList.map(group => {
      group.JobChecklistList.map(jobChecklist => {
        jobChecklistIds.push(jobChecklist.JobChecklistId);
      })
    })
  });

  let index = jobChecklistIds.indexOf(parameter) + 1;
  if (index >= 0 && index <= jobChecklistIds.length - 1) {
    let id = jobChecklistIds[index];
    editJobChecklist({ parameter: { key: id }, sectionComponent, pageComponent, sectionName, uie });
  }
}

export function openAssessmentChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  window.open('/assessment-checklist/detail/' + pageComponent.props.jobId);
}
